var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Location_Icon",
    "data-name": "Location Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1963",
    "data-name": "Rectangle 1963",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4204",
    "data-name": "Group 4204",
    transform: "translate(1.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2216335_location_map_map_pin_marker_pin_icon",
    "data-name": "2216335_location_map_map pin_marker_pin_icon",
    transform: "translate(1.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6012",
    "data-name": "Path 6012",
    d: "M34.051,20.4A8.929,8.929,0,0,1,43,29.348c0,2.053-1.464,5.014-4.352,8.8a64.212,64.212,0,0,1-4.3,5.039l-.3.311-.3-.311a64.214,64.214,0,0,1-4.3-5.039c-2.888-3.785-4.352-6.746-4.352-8.8A8.93,8.93,0,0,1,34.051,20.4Zm0,21.887c.66-.707,2.309-2.516,3.939-4.653,2.732-3.582,4.176-6.447,4.176-8.286a8.115,8.115,0,1,0-16.229,0c0,1.838,1.444,4.7,4.176,8.286C31.743,39.771,33.391,41.58,34.051,42.287Zm0-17.5a4.416,4.416,0,1,1-3.1,1.293A4.37,4.37,0,0,1,34.051,24.79Zm0,7.945a3.58,3.58,0,1,0-2.507-1.048A3.528,3.528,0,0,0,34.051,32.735Z",
    transform: "translate(-24.829 -20.129)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6012_-_Outline",
    "data-name": "Path 6012 - Outline",
    d: "M34.072,20.15a9.2,9.2,0,0,1,9.222,9.222c0,2.114-1.478,5.124-4.392,8.946a64.165,64.165,0,0,1-4.3,5.039l-.533.552-.533-.552a64.363,64.363,0,0,1-4.3-5.039c-2.914-3.822-4.392-6.832-4.392-8.946a9.2,9.2,0,0,1,9.222-9.222Zm0,22.82.064-.067a63.465,63.465,0,0,0,4.247-4.981c2.826-3.705,4.259-6.582,4.259-8.55a8.57,8.57,0,1,0-17.14,0c0,1.968,1.433,4.845,4.259,8.55A63.611,63.611,0,0,0,34.008,42.9Zm0-21.989a8.373,8.373,0,0,1,8.391,8.391c0,1.9-1.458,4.817-4.217,8.435-1.636,2.146-3.3,3.967-3.935,4.651l-.238.255-.238-.255c-.638-.683-2.3-2.5-3.935-4.651-2.759-3.619-4.217-6.536-4.217-8.435a8.373,8.373,0,0,1,8.391-8.391Zm0,20.775c.747-.812,2.211-2.45,3.655-4.344,2.671-3.5,4.084-6.284,4.084-8.04a7.739,7.739,0,1,0-15.477,0c0,1.756,1.412,4.536,4.084,8.04C31.861,39.306,33.325,40.945,34.072,41.757Zm0-17.242a4.716,4.716,0,1,1-3.31,1.381A4.666,4.666,0,0,1,34.072,24.515Zm0,8.73a4.064,4.064,0,1,0-2.849-1.19A4.007,4.007,0,0,0,34.072,33.245Zm0-7.9a3.885,3.885,0,1,1-2.722,1.138A3.84,3.84,0,0,1,34.072,25.346Zm0,7.067a3.233,3.233,0,1,0-2.261-.947A3.182,3.182,0,0,0,34.072,32.414Z",
    transform: "translate(-24.85 -20.15)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.566ccbf19c0ecb61565483f5db072527.svg";
export { ForwardRef as ReactComponent };